const IconTab1 = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0604 17L10.9992 6.92473C10.7135 6.65188 10.3337 6.49963 9.93864 6.49963C9.5436 6.49963 9.16377 6.65188 8.8781 6.92473L6.9386 8.86423C6.65775 9.14575 6.50002 9.52718 6.50002 9.92484C6.50002 10.3225 6.65775 10.7039 6.9386 10.9855L16.9992 21.0609C17.2807 21.3417 17.6621 21.4994 18.0597 21.4994C18.4574 21.4994 18.8388 21.3417 19.1203 21.0609L21.0604 19.121C21.1998 18.9817 21.3103 18.8164 21.3857 18.6344C21.4611 18.4524 21.4999 18.2574 21.4999 18.0604C21.4999 17.8634 21.4611 17.6683 21.3857 17.4864C21.3103 17.3044 21.1998 17.1393 21.0604 17ZM7.99918 9.92488L9.9386 7.98545L12.5636 10.6105L10.6235 12.5507L7.9985 9.9257L7.99918 9.92488ZM18.0598 20L11.6841 13.6109L13.6241 11.6707L20 18.0607L18.0598 20Z"
      fill="currentColor"
    />
    <path
      d="M5.75 12.5L4.25001 14L5.75 15.5L7.24998 14L5.75 12.5Z"
      fill="currentColor"
    />
    <path
      d="M14 4.25003L12.5 5.75002L14 7.25001L15.5 5.75002L14 4.25003Z"
      fill="currentColor"
    />
    <path
      d="M5.75002 4.25002L4.25003 5.75L5.75002 7.24999L7.25 5.75L5.75002 4.25002Z"
      fill="currentColor"
    />
    <path d="M7.25 0.5H0.5V7.25H2V2H7.25V0.5Z" fill="currentColor" />
  </svg>
);

export default IconTab1;
